import { FunctionComponent } from "react";
import styles from "../../stylesheets/components/header-mobile/book-enquire-links.module.css";
import { ActionLinks } from "../../types/index.js";
import { getEnquiryBookingLinks } from "../../utils/utils.js";
import SmartLink from "../SmartLink.js";

interface Props {
  actionLinks: ActionLinks;
  isPreview: boolean;
  onClick: () => void;
}

const BookEnquireLinks: FunctionComponent<Props> = ({
  actionLinks,
  isPreview,
  onClick,
}) => {
  const links = getEnquiryBookingLinks(actionLinks);

  return !links.length ? null : (
    <div className={styles.BookEnquireLinks}>
      {getEnquiryBookingLinks(actionLinks).map(({ type, href, label }) => (
        <SmartLink
          key={type}
          isPreview={isPreview}
          anchorAttrs={{
            href,
            className: styles.BookEnquireLinks__Item,
            onClick,
          }}
        >
          {label}
        </SmartLink>
      ))}
    </div>
  );
};

export default BookEnquireLinks;
